import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Email from '../../api/Email';
import './EmailSubscribe.css';

export default class EmailSubscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailValue: '',
      loading: false,
      submitted: false,
    }
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      loading: true
    });
    let email = this.state.emailValue;
    email = email.toLowerCase();
    Email.addEmail(email, (response) => {
      if (response) {
        this.setState({
          submitted: true,
          loading: false
        });
      }
    })
    .catch((error) => {
      this.setState({
        loading: false,
      })
    });
  }

  handleEmailChange(event) {
    this.setState({
      emailValue: event.target.value
    });
  }

  renderSubmitted() {
    return (
      <div className="youre-in">
        Awesome! You're in!
      </div>
    )
  }

  renderCollection() {
    const {
      emailValue,
      loading
    } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        <TextField
          hintText="Email"
          className="email-text-field"
          value={emailValue}
          onChange={this.handleEmailChange}
        />
      {loading
        ? <FlatButton
            label="Loading ..."
            backgroundColor="white"
            hoverColor="white"
            className="btn-beta"
          />
        : <FlatButton
            type="submit"
            label="Sign up"
            backgroundColor="white"
            hoverColor="white"
            className="btn-beta"
          />}
      </form>
    )
  }

  render () {
    const {
      submitted
    } = this.state;

    return (
      <div>
        {submitted
          ? this.renderSubmitted()
          : this.renderCollection()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/signin/EmailSubscribe.jsx